import "./Contact.module.css";
import EnTTe from "@/reusable_sections/Header";
import ParlonsDeVosDrains from "./sections/ParlonsDeVosDrains";
import HeuresDOuverture from "./sections/HeuresDOuverture";
import PiedDePage from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <EnTTe />
      <ParlonsDeVosDrains />
      <HeuresDOuverture />
      <PiedDePage />
    </div>;
}